import Inputs from "./Inputs";
import Results from "./Results";

function App() {
  return (
    <div className="app">
      <Inputs />
      <Results />
    </div>
  );
}

export default App;
